var $ = require('jquery');

$(function () {

    function setMasonryColumnLayout(cardType) {
        var column1 = 0, column2 = 0, column3 = 0;

        $('#_810-twitter-wrapper ._810-twitter-timeline__wrapper:nth-child(' + cardType + 'n+1)').filter(function (i) {
            var getHeight1 = this.offsetHeight + 30;
            column1 += getHeight1;
        });

        $('#_810-twitter-wrapper ._810-twitter-timeline__wrapper:nth-child(' + cardType + 'n+2)').filter(function (i) {
            var getHeight3 = this.offsetHeight + 30;
            column2 += getHeight3;
        });

        $('#_810-twitter-wrapper ._810-twitter-timeline__wrapper:nth-child(' + cardType + 'n)').filter(function (i) {
            var getHeight3 = this.offsetHeight + 30;
            column3 += getHeight3;
        });
        $('#_810-twitter-wrapper').css("height", (Math.max(column1, column2, column3) + 80) + "px");
    }


    function initTwitterDefaultView() {
        if ($('#_810-twitter-wrapper').length > 0) {
            var HorizontalFlag = $('#_810-twitter-wrapper').attr('data-horizontal').toLowerCase().toString();
            var isDisplayedHorizontal = JSON.parse(HorizontalFlag);

            if ($(window).width() <= 991) {
                initSliderView(true);
            }
            else if ($(window).width() > 991 && $(window).width() <= 1199) {
                $("#_810-twitter-wrapper").addClass("masonry-two-col");
                setMasonryColumnLayout(2);
                initSliderView(isDisplayedHorizontal);
            }
            else {
                $("#_810-twitter-wrapper").removeClass("masonry-two-col");
                setMasonryColumnLayout(3);
                initSliderView(isDisplayedHorizontal);
            }
        }
    }


    initTwitterDefaultView();

    $(window).on('resize orientationchange', function () {
        initTwitterDefaultView();
    });


    function initSliderView(slickState) {
        if (slickState) {
            if ($('#_810-twitter-wrapper').length > 0) {
                var showArrows = true;
                var numInsights = $('._810-twitter-timeline__wrapper').length;
                var fullWidthMode = false;
                if (numInsights > 2) {
                    showArrows = true;
                }

                var slider = $('#_810-twitter-wrapper');

                slider.slick({
                    arrows: showArrows,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 1,
                    centerMode: false,
                    centerPadding: '60px',
                    variableWidth: true,
                    mobileFirst: true,
                    responsive: [
                                {
                                    settings: {
                                        settings: 'unslick'
                                    }
                                }
                    ],
                    rtl: window.GenericUtilities.isRTL()
                });
            }
        } else {
            if ($('#_810-twitter-wrapper').hasClass('slick-initialized')) {
                $('#_810-twitter-wrapper').slick('unslick');
            }
        }
    }
});